import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
    max-width: 100%;
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 10px;
`;

// Texto de apoio abaixo de um campo, para o que o rótulo não diz sozinho:
// "Em montagem" esconder a seletiva do patrocinador, o anexo só aparecer quando
// ela for publicada, etc.
export const FieldHint = styled.p`
  margin: -8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral.gray7};
`;

// Anexo de apresentação: rótulo próprio + uploader (o label do FileUploader fica
// vazio para não duplicar o texto).
export const PresentationField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  > label {
    font-weight: 600;
  }
`;

// Rótulo do campo à esquerda e "Gerar apresentação" à direita: o botão é uma
// alternativa ao upload manual, então vive ao lado do campo, não nas ações do
// formulário (que salvam a seletiva inteira).
export const PresentationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  > label {
    font-weight: 600;
  }
`;

// Dois botões (enviar por e-mail + gerar) que quebram juntos no mobile.
export const PresentationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

// Portador do `title` do botão de envio.
//
// ⚠️ Existe porque o NAVEGADOR NÃO DISPARA eventos de mouse em elemento
// desabilitado: o `title` no próprio <button disabled> nunca aparecia, e o
// admin não descobria o que faltava para enviar (pedido do cliente,
// 18/08/2026). O wrapper está habilitado, então o hover chega nele.
export const TooltipWrapper = styled.span`
  display: inline-flex;
`;

export const Territory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > label {
    font-weight: 600;
  }
`;

export const Uf = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  h4 {
    margin: 0;
  }
`;

export const Cities = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const City = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  background: ${({ theme }) => theme.colors.primary.main};
  /* variant: "light" deixa o texto preto (Admin); o branco é o padrão (área comum). */
  color: ${({ theme, variant }) =>
    variant === "light"
      ? theme.colors.neutral.black
      : theme.colors.neutral.white};
  border-radius: 16px;
  padding: 4px 10px;
  font-size: 13px;

  svg {
    cursor: pointer;
  }
`;
